import { useLocation, useNavigate } from 'react-router-dom'
import ContentDictionary from '../../../../components/contentDictionary/contentDictionary'
import './mainHeader.css'
import SecondHandDictionary from '../../../../components/secondHandDictionary/secondHandDictionary'

export default function MainHeader() {
  const location = useLocation()
  const naviagte = useNavigate()

  //当前页面判断
  const selectedPage = () => {
    const current = location.pathname
    const items = new Map([
      ['/homepage', '首页'],
      ['/userManage', '用户列表'],
      ['/swiperManage', '轮播图列表'],
      ['/houseManage', '房源列表'],
      ['/postManage', '帖子列表'],
      ['/commentManage', '评论列表'],
      ['/eventManage', '活动管理'],
      ['/studyManage', '学业分享管理'],
      ['/rentManage', '租房攻略管理'],
      ['/beforeTravelManage', '留学攻略管理'],
      ['/newHouse', '编辑房源'],
      ['/newContent', '编辑内容'],
      ['/postDetail', '帖子详情'],
      ['/memberManage', '成员列表'],
      ['/secondHand', '闲置二手'],
      ['/fallGroup', '25Fall抱团'],
      ['/rentReadme', '租房必看'],
    ])
    let pages = items.get(current)
    return pages
  }

  const quit = () => {
    localStorage.removeItem('username')
    localStorage.removeItem('Authorization')
    console.log('user quit')
    naviagte('/login', { state: { from: location } })
  }
  return (
    <div className="mainHeader">
      <div className="section user">
        <span> {localStorage.getItem('username')}</span>
        <span
          style={{ marginLeft: '20px' }}
          className="userQuit"
          onClick={quit}
        >
          退出登录
        </span>
      </div>
      <div className="section currentPage">
        <span className="title">{selectedPage()}</span>

        <span style={{ float: 'right', fontSize: '18px' }}>
          {selectedPage() === '学业分享管理' ? <ContentDictionary /> : null}
        </span>
        <span style={{ float: 'right', fontSize: '18px' }}>
          {selectedPage() === '租房攻略管理' ? <ContentDictionary /> : null}
        </span>
        <span style={{ float: 'right', fontSize: '18px' }}>
          {selectedPage() === '留学攻略管理' ? <ContentDictionary /> : null}
        </span>
        <span style={{ float: 'right', fontSize: '18px' }}>
          {selectedPage() === '闲置二手' ? <SecondHandDictionary /> : null}
        </span>
      </div>
    </div>
  )
}
